export default {
  "home.eyebrow": "Das AllChinaBuy-Ressourcen-Hub",
  "home.h1": "AllChinaBuy Spreadsheet: Produkte, Verkäufer und Kaufressourcen finden",
  "home.heroCopy": "Entdecken Sie kuratierte AllChinaBuy-Spreadsheet-Ressourcen, Produktfunde, Informationen zu vertrauenswürdigen Verkäufern, QC-Leitfäden, Versandressourcen und praktische Kauftipps — alles in einem einfach zu bedienenden Hub.",
  "home.trustText": "Unabhängige Ressource · Regelmäßig aktualisiert · Für smartere Produktrecherche",

  "home.categoriesTitle": "Produktkategorien durchstöbern",
  "home.categoriesSubtitle": "Springen Sie direkt zur gewünschten Kategorie. Jeder Link öffnet die Hauptwebsite mit kuratierten Produkten.",
  "home.dropdownLabel": "Kategorie wählen",
  "home.dropdownPlaceholder": "Kategorie auswählen…",

  "home.valueTitle": "Alles, was Sie für die AllChinaBuy-Produktrecherche brauchen",
  "home.valueSubtitle": "Sechs fokussierte Bereiche, die Sie vom Stöbern zum sicheren Kauf führen.",
  "home.value1Title": "Spreadsheet",
  "home.value1Desc": "Organisierte Produkt- und Verkäuferressourcen in einem Hub.",
  "home.value2Title": "Vertrauenswürdige Verkäufer",
  "home.value2Desc": "Recherchieren Sie Verkäufer und vergleichen Sie Infos vor dem Kauf.",
  "home.value3Title": "QC-Ressourcen",
  "home.value3Desc": "Verstehen Sie Qualitätskontroll-Fotos und Warnzeichen.",
  "home.value4Title": "Versandleitfäden",
  "home.value4Desc": "Erfahren Sie mehr über Methoden, Kosten und wichtige Punkte.",
  "home.value5Title": "Lager-Leitfaden",
  "home.value5Desc": "Verstehen Sie Lagerung, Inspektion und Versandabläufe.",
  "home.value6Title": "Kaufleitfäden",
  "home.value6Desc": "Schritt-für-Schritt-Ressourcen für jedes Niveau.",

  "home.trustTitle": "Entwickelt für bessere AllChinaBuy-Recherche",
  "home.trustCopy": "Produkte zu finden ist leicht. Nützliche Informationen vor dem Kauf zu finden, ist schwieriger. Unser Ziel ist es, verstreute AllChinaBuy-Ressourcen in klaren Seiten, praktischen Leitfäden und Sicherheitsinformationen zu bündeln, damit Sie mit mehr Sicherheit recherchieren können.",
  "home.trust1Title": "Organisiert",
  "home.trust1Desc": "Ressourcen nach Kategorie und Absicht gruppiert.",
  "home.trust2Title": "Transparent",
  "home.trust2Desc": "Informationen nach Möglichkeit geprüft und klar datiert.",
  "home.trust3Title": "Praktisch",
  "home.trust3Desc": "Leitfäden mit Fokus auf die Entscheidungen, die Sie wirklich treffen müssen.",

  "home.articleTitle": "Aus dem Ressourcen-Hub",
  "home.articleSubtitle": "Lesen Sie unseren ausführlichen Leitfaden, um das Beste aus dem AllChinaBuy Spreadsheet herauszuholen.",
  "home.articleCardTitle": "AllChinaBuy Spreadsheet: Der komplette Leitfaden",
  "home.articleExcerpt": "Erfahren Sie, was das Spreadsheet ist, wie Sie es Schritt für Schritt nutzen, Verkäufer recherchieren, QC-Fotos prüfen und den Versand planen — mit praktischen Tipps und einer Vergleichstabelle.",
  "home.articleReadMore": "Den kompletten Leitfaden lesen",
  "home.articleMeta": "Unabhängiger Leitfaden · Regelmäßig aktualisiert",
  "home.articlesTitle": "Neueste Leitfäden und Ressourcen",
  "home.articlesSubtitle": "Entdecken Sie unsere ausführlichen Hauptleitfäden zu Spreadsheet, Verkäufern, QC, Versand, Lager und mehr.",
  "home.readNow": "Jetzt lesen",
  "home.relatedGuides": "Verwandte Leitfäden",
  "home.articleNotFound": "Leitfaden nicht gefunden",

  "home.faqTitle": "Häufig gestellte Fragen",
  "home.faqSubtitle": "Schnelle Antworten auf die Fragen, die uns am häufigsten gestellt werden.",
  "home.faq1Q": "Was ist das AllChinaBuy Spreadsheet?",
  "home.faq1A": "Es ist eine organisierte Sammlung von Produktlinks, Kategorienotizen und Kaufressourcen, die Ihnen hilft, Produkte und Verkäufer vor dem Kauf zu recherchieren.",
  "home.faq2Q": "Ist das AllChinaBuy Spreadsheet kostenlos?",
  "home.faq2A": "Ja. Das Spreadsheet und dieses Ressourcen-Hub sind kostenlos durchstöberbar, und Sie müssen nichts bezahlen, um die Kategorien und Links anzusehen.",
  "home.faq3Q": "Wie finde ich vertrauenswürdige Verkäufer?",
  "home.faq3A": "Achten Sie auf klare Produktfotos, eine konsistente Angebotshistorie und Bewertungen, die den tatsächlichen Artikel erwähnen. Gleichen Sie Verkäufer ab und prüfen Sie QC-Fotos vor Ihrer Entscheidung.",
  "home.faq4Q": "Was sind QC-Fotos?",
  "home.faq4A": "QC-Fotos (Qualitätskontrolle) zeigen Ihren tatsächlichen Artikel vor dem Versand. Sie helfen, Mängel, falsche Farben oder Größenprobleme zu erkennen, bevor der Artikel das Lager verlässt.",
  "home.faq5Q": "Wie funktioniert der Versand?",
  "home.faq5A": "Internationaler Versand wird meist nach Gewicht oder Größe berechnet. Schnellere Methoden kosten mehr, während Economy-Linien günstiger, aber langsamer sind. Planen Sie den Versand früh, um die Gesamtkosten zu verstehen.",
  "home.faq6Q": "Ist dies die offizielle AllChinaBuy-Website?",
  "home.faq6A": "Nein. Dies ist eine unabhängige Informationsressource und nicht die offizielle AllChinaBuy-Website. Überprüfen Sie wichtige Details immer direkt vor dem Kauf.",

  "home.ctaTitle": "Bereit, mehr AllChinaBuy-Ressourcen zu entdecken?",
  "home.ctaCopy": "Beginnen Sie mit dem Spreadsheet, vergleichen Sie Ihre Optionen, lernen Sie QC und Versand kennen und entdecken Sie die neuesten Kaufressourcen.",
  "home.ctaPrimary": "AllChinaBuy Spreadsheet entdecken",
  "home.ctaSecondary": "Die Kaufleitfäden lesen",
};